<div class="ion-page modal-dialog">
  <div class="modal-content">
    <div class="modal-body">
      <div class="news-navigation">
        <div class="list">
          <h4 class="t-h4 mb-4">{{ 'MODALS.NEWS_INFO.NEWS_CATEGORIES' | translate }}</h4>
          <div class="list-item" *ngFor="let news of listSet; index as i">
            <a class="btn btn-block btn-secondary" (click)="selectedCategory(news)">
              <img *ngIf="news.term_thumbnail != undefined" src="{{news.term_thumbnail.url}}" alt="...">
              <span></span> {{news.name}}
            </a>
          </div>
        </div>
        <ion-icon class="close icon icon-close" (click)="dismiss()"></ion-icon>
      </div>
    </div>
  </div>
</div>